/**
 * Constants and Placeholders for My Dealer Feature
 */

/**
 * Default cluster code placeholder
 */
export const CLUSTER_CODE_PLACEHOLDER = {
  SH3_Name__c: null,
  SH3_Code__c: null,
  Cluster_Description__c: "",
  CLUSTER_CODE__c: "",
};

/**
 * Default territory autocomplete placeholder
 */
export const TERRITORY_PLACEHOLDER = {
  attributes: null,
  Id: null,
  SH2_Name__c: null,
  SH2_Code__c: null,
  Name: null,
  SH3_Code__c: null,
};

/**
 * Default dealer placeholder
 */
export const DEALER_PLACEHOLDER = {
  attributes: null,
  Id: null,
  Dealer_Name__c: null,
  DealerClass__c: null,
  DealerType1__c: null,
  DealerLatitude__c: null,
  DealerLongitude__c: null,
  PrimaryTSICode__c: null,
  DealerCode__c: null,
  RecordTypeId: null,
  Customer_Code__c: null,
  CustomerName__c: null,
};

/**
 * Default GPS coordinates (Pune, India)
 */
export const DEFAULT_COORDINATES = {
  latitude: 18.516726,
  longitude: 73.856255,
};

/**
 * Check-in distance threshold in meters
 */
export const CHECK_IN_DISTANCE_THRESHOLD = 100; // meters

/**
 * User types that require special cluster filtering
 */
export const SPECIAL_USER_TYPES = ["MH3", "RBDM Collaborator"];

/**
 * User types that can auto-populate from MTP
 */
export const MTP_ENABLED_USER_TYPES = ["SH6", "SH5", "MH3", "RBDM Collaborator"];

/**
 * Loading states
 */
export const LOADING_STATES = {
  LOADING: "Loading",
  SUCCESS: "true",
  NO_DATA: "false",
};
